$(document).ready(function() {
  
    var allowClickAction = false;


    
        // Function to switch to the last image
        function switchToLastImage() {
            const items = $('.thumbnail-list li.thumbnail-list__item');
            if (items.length > 0) {
                const lastItem = items.last();
                const lastButton = lastItem.find('button');
                
                if (lastButton.length > 0 && lastButton.attr('aria-current') !== 'true') {
                    console.log('Switching to last image');
                    lastButton.trigger('click');
                    
                    // Ensure the last image gets the class
                    setTimeout(function() {
                        const mediaItems = $('.product__media-list li.product__media-item');
                        if (mediaItems.length > 0) {
                            mediaItems.removeClass('last-media-item');
                            mediaItems.last().addClass('last-media-item');
                        }
                    }, 100);
                }
            }
        }
    

    $(document).on('input change', '.product-custom-field-input', function() {
        
        setTimeout(function() {
            allowClickAction = true;
        }, 1000);

        // Switch to last image when any field is changed
        if(allowClickAction == true){ 
            switchToLastImage();
        }

        var parentContainer = $(this).closest('.product-custom-field-input-container');
        var inputVal = $(this).val();
        var labelText = parentContainer.siblings('label').text().toLowerCase();
    
        var event_text = $(this).siblings('label').text().toLowerCase();

        // Get the last image's media container instead of all images
        var overlayContainer = $('.product__media-wrapper .last-media-item .product-media-container');
        
        // If last media container doesn't exist yet, find the last item and create it
        if (overlayContainer.length === 0) {
            const items = $('.product__media-list li.product__media-item');
            if (items.length > 0) {
                const lastItem = items.last();
                lastItem.addClass('last-media-item');
                overlayContainer = lastItem.find('.product-media-container');
            }
        }
        
        var overlayClass = '';
        var overlayText = '';

        if (labelText.includes('name')) {


            function updateCharLength(input) {
            const max = input.getAttribute('maxlength') || 0;
            const length = input.value.length;
            const counter = input.closest('.product-custom-field-input-container')
                                ?.querySelector('.product-custom-field-character-length');

                if (counter) {
                    counter.innerText = `${length} / ${max}`;
                }
            }

            const nameInput = document.querySelector('#product-custom-field-69c3bf8d76e3c374103d19a5');

            // On input: remove invalid characters (numbers, emojis, special characters)
            nameInput.addEventListener('input', function(e) {
                e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                shrinkOverlayText('.overlay-text.name-overlay');
                updateCharLength(this);
            });

            // On keydown: prevent typing invalid characters
            nameInput.addEventListener('keydown', function(e) {
                // Allow Backspace, Delete, Tab, Arrow keys, Space
                if ([8, 9, 32, 37, 38, 39, 40, 46].includes(e.keyCode)) return;

                // Block anything that's not A-Z or a-z
                if (!(e.keyCode >= 65 && e.keyCode <= 90)) {
                    e.preventDefault();
                }
            });

            // On keyup: adjust overlay text size
            nameInput.addEventListener('keyup', function() {
                shrinkOverlayText('.overlay-text.name-overlay');
            });

            // Initial overlay adjustment
            shrinkOverlayText('.overlay-text.name-overlay');

            overlayClass = 'name-overlay';
            overlayText = inputVal;

        } else if (event_text.includes('event') || labelText.includes('event')) {

            overlayClass = 'event-overlay';
            overlayText = inputVal;

            function updateCharLength(input) {
            const max = input.getAttribute('maxlength') || 0;
            const length = input.value.length;
            const counter = input.closest('.product-custom-field-input-container')
                                ?.querySelector('.product-custom-field-character-length');

                if (counter) {
                    counter.innerText = `${length} / ${max}`;
                }
            }

            const eventInput = document.querySelector('#product-custom-field-6883a5ce5df00255eaf6896f');

            // On input: allow only letters, numbers, and spaces
            eventInput.addEventListener('input', function(e) {
                e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, ''); // remove special characters & emoji
                updateCharLength(this);
            });

            // On keydown: block special characters and emoji
            eventInput.addEventListener('keydown', function(e) {
                // Allow: Backspace, Delete, Tab, Arrow keys, Space
                if ([8, 9, 32, 37, 38, 39, 40, 46].includes(e.keyCode)) return;

                // Block anything that is not a letter or number
                if (!( (e.keyCode >= 48 && e.keyCode <= 57) || // numbers 0-9
                    (e.keyCode >= 65 && e.keyCode <= 90) )) { // letters A-Z
                    e.preventDefault();
                }
            });

            // Handle selects if used as text (swatch simulation)
            if ($(this).is('select')) {
            $('.product-custom-field-input').each(function () {
                if ($(this).is('input[type="text"]')) {
                if( $(this).parents('.product-custom-field-input-container').siblings('label').text().toLowerCase().includes('event') ) {
                    var spaceKeyEvent = $.Event('keydown', { keyCode: 32, which: 32 });
                    $(this).val(inputVal).trigger('focus').trigger(spaceKeyEvent);
                    $('input[name="properties[Event]"]').val(inputVal);
                    updateCharLength(this);
                }
                }
            });
            }
        } else if (event_text.includes('message') || labelText.includes('message')) {
            overlayClass = 'message-overlay';
            overlayText = inputVal;

            function updateCharLength(input) {
                const max = input.getAttribute('maxlength') || 0;
                const length = input.value.length;
                const counter = input.closest('.product-custom-field-input-container')
                                    ?.querySelector('.product-custom-field-character-length');

                if (counter) {
                    counter.innerText = `${length} / ${max}`;
                }
            }

            const messageInput = document.querySelector('#product-custom-field-6883a6d85df00255eaf6898c');

            // On input: allow only letters, numbers, and spaces
            messageInput.addEventListener('input', function(e) {
                e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, ''); // remove special characters & emoji
                updateCharLength(this);
            });

            // On keydown: block special characters and emoji
            messageInput.addEventListener('keydown', function(e) {
                // Allow: Backspace, Delete, Tab, Arrow keys, Space
                if ([8, 9, 32, 37, 38, 39, 40, 46].includes(e.keyCode)) return;

                // Block anything that is not a letter or number
                if (!( (e.keyCode >= 48 && e.keyCode <= 57) || // numbers 0-9
                        (e.keyCode >= 65 && e.keyCode <= 90) )) { // letters A-Z
                    e.preventDefault();
                }
            });

            // Handle selects if used as text (swatch simulation)
            if ($(this).is('select')) {
                $('.product-custom-field-input').each(function () {
                    if ($(this).is('input[type="text"]')) {
                        if ($(this).parents('.product-custom-field-input-container').siblings('label').text().toLowerCase().includes('message')) {
                            var spaceKeyEvent = $.Event('keydown', { keyCode: 32, which: 32 });
                            $(this).val(inputVal).trigger('focus').trigger(spaceKeyEvent);
                            $('input[name="properties[Special Message]"]').val(inputVal);
                            updateCharLength(this);
                        }
                    }
                });
            }
        }
        else {
        console.log("Other input:", inputVal);
        return;
        }

        // Only proceed if we have a valid overlay container (the last image)
        if (overlayContainer.length === 0) {
            console.log("Last image container not found yet");
            return;
        }

        // Find the specific overlay div inside the container (only on last image)
        if (overlayClass === 'name-overlay') {
            // Append name overlay directly
            var existingOverlay = overlayContainer.find('.' + overlayClass);

            if (existingOverlay.length === 0) {
                var newDiv = $('<div class="overlay-text ' + overlayClass + '"></div>').text(overlayText);
                overlayContainer.css('position', 'relative').append(newDiv);
            } else {
                existingOverlay.text(overlayText);
            }
        } else {
            // Wrap event/message overlays inside a shared wrapper
            var wrapper = overlayContainer.find('.overlay-wrapper');

            if (wrapper.length === 0) {
                wrapper = $('<div class="overlay-wrapper"></div>');
                overlayContainer.css('position', 'relative').append(wrapper);
            }

            var existingOverlay = wrapper.find('.' + overlayClass);
            if (existingOverlay.length === 0) {
                var newDiv = $('<div class="overlay-text ' + overlayClass + '"></div>').text(overlayText);
                wrapper.append(newDiv);
            } else {
                existingOverlay.text(overlayText);
            }
        }

        // Style the divs as required for each specific class
        $('.overlay-text.name-overlay').each(function() {
            var div = $(this);
            div.css({
                position: 'absolute',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.6)',
                width: '100%',
                textAlign: 'center'
            });
        });

        // Set individual positions for each specific class
        $('.name-overlay').css({
            top: '5%',
            zIndex: 1,
            color: '#F5D201',
            fontFamily: 'Anothershabby, sans-serif',
            transform: 'rotate(-7deg)'
        });
        
    });


    
    function addPreviewButton() {

        const productFormButtons = document.querySelector('.product-form__buttons');

        if (!productFormButtons) return;

        // Prevent duplicate
        if (productFormButtons.querySelector('.preview-button')) return;

        const previewButton = document.createElement('button');
        previewButton.className = 'button preview-button';
        previewButton.type = 'button';

        previewButton.innerHTML = `
        <svg viewBox="0 0 1280 1042.0374" width="20" height="20" fill="#fff" class="mr-2">
        <path d="M512 192q-84 0-161 23-77 24-143 66T89 382Q36 441 0 512q36 71 89 130t119 101q66 42 143 66 77 23 161 23t161-23q77-24 143-66t119-101q53-59 89-130-36-71-89-130T816 281q-66-42-143-66-77-23-161-23zm252 170q46 28 83.5 66.5T914 512q-29 45-66.5 83.5T764 662q-56 36-120.5 55T512 736q-67 0-131.5-19T260 662q-46-28-83.5-66.5T110 512q29-45 66.5-83.5T260 362q2-2 5-4l6-4q-7 21-11 43t-4 45q0 53 20 100 20 46 55 81t81 55q47 20 100 20t100-20q46-20 81-55t55-81q20-47 20-100 0-23-4-45t-11-43l6 4q3 2 5 4zm-252 54q0 40-28 68t-68 28q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68z"/>
        </svg>
        Preview Now`;

        productFormButtons.appendChild(previewButton);

    }


    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.preview-button');
        if (!btn) return;

        console.log('Preview clicked');

        // Check if screen width is less than 767px
        if (window.innerWidth < 767) {
            const $lastBtn = $('.thumbnail-list .thumbnail-list__item:last-child button');
            
            // Trigger click without any conditions
            if ($lastBtn.length) {
                $lastBtn.trigger('click');
            }
        } else {
            // Original logic for larger screens
            const $lastBtn = $('.thumbnail-list .thumbnail-list__item:last-child button');

            if ($lastBtn.length && $lastBtn.attr('aria-current') !== 'true') {
                $lastBtn.trigger('click');
            }
        }
    });

    


    // value add by js in inputs start

        // ===== FUNCTIONS =====

        // Event (swatch select)
        function setDefaultEvent() {
            const eventValue = "Happy Easter";

            const container = $('.product-custom-field-item').filter(function () {
                return $(this).find('label').text().toLowerCase().includes('event');
            });

            const select = container.find('select.product-custom-field-input');
            const swatches = container.find('.swatch-option');

            if (select.length) {
                select.val(eventValue);

                swatches.removeClass('selected');
                swatches.each(function () {
                    if ($(this).text().trim() === eventValue) {
                        $(this).addClass('selected');
                    }
                });

                select.trigger('change');
                select[0].dispatchEvent(new Event("change", { bubbles: true }));
            }
        }


        // Special Message (swatch)
        function setDefaultMessage() {
            const messageValue = "With Love This Easter";

            const container = $('.product-custom-field-item').filter(function () {
                return $(this).find('label').text().toLowerCase().includes('special message');
            });

            const select = container.find('select.product-custom-field-input');
            const swatches = container.find('.swatch-option');

            if (select.length) {
                select.val(messageValue);

                swatches.removeClass('selected');
                swatches.each(function () {
                    if ($(this).text().trim() === messageValue) {
                        $(this).addClass('selected');
                    }
                });

                select.trigger('change');
                select[0].dispatchEvent(new Event("change", { bubbles: true }));
            }
        }


        // Name input
        function setDefaultName() {
            const input = $('#product-custom-field-69c3bf8d76e3c374103d19a5');

            if (input.length) {
                const el = input[0]; // DOM element

                const value = 'Michael';

                // Proper native setter (important for React / Shopify / frameworks)
                const nativeSetter = Object.getOwnPropertyDescriptor(
                    window.HTMLInputElement.prototype,
                    "value"
                ).set;

                nativeSetter.call(el, value);

                // Trigger events
                el.dispatchEvent(new Event("input", { bubbles: true }));
                el.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }


        // Run all defaults
        function setDefaults() {
            setDefaultName();
            setDefaultEvent();
            setDefaultMessage();
            addPreviewButton();
        }


        // ===== WATCH ENTIRE BODY FIRST =====
        const observer = new MutationObserver(function (mutations, obs) {

            const container = document.querySelector('.product-custom-fields-container');

            if (container && $('.product-custom-field-item').length) {

                console.log('Fields detected ✅');

                setDefaults();

                // stop after success (optional)
                obs.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    // value add by js in inputs end 


    function showLoader() {
        const loader = document.querySelector('.product-form__submit .loading__spinner');
        const btn = document.querySelector('.product-form__submit');

        if (loader) loader.classList.remove('hidden');

        if (btn) {
            btn.classList.add('loaderbtn');
            btn.disabled = true;
        }
    }

    function hideLoader() {
        const loader = document.querySelector('.product-form__submit .loading__spinner');
        const btn = document.querySelector('.product-form__submit');

        if (loader) loader.classList.add('hidden');

        if (btn) {
            btn.classList.remove('loaderbtn');
            btn.disabled = false;
        }
    }

    $(document).ready(function() {
        // Listen for Add to Cart button click
          $('.product-form__submit').on('click', function(event) {

                console.log('add to cart button clicked');
                event.preventDefault();
                showLoader();

                var customEventInput = document.querySelector('input[name="properties[Custom Event]"]');
                var eventInput = document.querySelector('input[name="properties[Event]"]');

                if (customEventInput && customEventInput.value.trim() !== '') {
                    if (eventInput) eventInput.value = '';
                }

                var customMessageInput = document.querySelector('input[name="properties[Custom Special Message]"]');
                var messageInput = document.querySelector('input[name="properties[Special Message]"]');

                if (customMessageInput && customMessageInput.value.trim() !== '') {
                    if (messageInput) messageInput.value = '';
                }

                var formData = $(this).closest('form').serialize();

                // ✅ IMPORTANT: add sections for drawer update
                formData += '&sections=cart-drawer,cart-icon-bubble';
                formData += '&sections_url=' + window.location.pathname;

                console.log(formData);

                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: formData,
                    dataType: 'json',

                    success: function(response) {

                    hideLoader();
                    console.log('Cart response:', response);

                    const cartDrawer = document.querySelector('cart-drawer');

                    // ✅ PRIMARY FIX (Dawn / modern themes)
                    if (cartDrawer && response.sections) {

                        cartDrawer.renderContents({
                        sections: response.sections
                        });

                        // 🔥 FIX: important for first item (empty cart issue)
                        cartDrawer.classList.remove('is-empty');

                        // ✅ Open drawer
                        if (typeof cartDrawer.open === 'function') {
                        cartDrawer.open();
                        } else {
                        cartDrawer.classList.add('active');
                        document.body.classList.add('overflow-hidden');
                        }

                    } else {

                        // 🔁 FALLBACK for custom themes
                        fetch('/?sections=cart-drawer,cart-icon-bubble')
                        .then(res => res.json())
                        .then(data => {

                            if (cartDrawer) {
                            cartDrawer.renderContents({
                                sections: data
                            });

                            cartDrawer.classList.remove('is-empty');

                            if (typeof cartDrawer.open === 'function') {
                                cartDrawer.open();
                            } else {
                                cartDrawer.classList.add('active');
                                document.body.classList.add('overflow-hidden');
                            }
                            }

                        })
                        .catch(err => console.error(err));
                    }

                    },

                    error: function(response) {
                    hideLoader();
                    console.log("Error:", response);
                    }
                });

                });
    });

    // Function to observe when the target element appears in the DOM
    function checkForElement() {
        const targetNode = document.body;
        const observer_event = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                $(mutation.addedNodes).each(function() {
                    if ($(this).find('.product-custom-field-input-container')) {
                        var condition = false;
                        $('.product-custom-field-input-container').find('.product-custom-field-input').each(function() {
                            if ($(this).val() !== '') {
                                $(this).trigger('input');
                                $(this).trigger('change');
                            }
                            condition = true;
                        });

                        if(condition){
                            observer_event.disconnect();
                        }
                    }
                });
            });
        });
    
        observer_event.observe(targetNode, {
            childList: true,
            subtree: true
        });
    }
    
    checkForElement();

    // Add overlay image to the last product image and ensure text overlays only appear there
    $(document).ready(function() {
        // Create a MutationObserver to watch for when product media items are loaded
        var observer = new MutationObserver(function(mutationsList, observer) {
            // Check if the product media items exist
            const items = $('.product__media-list li.product__media-item');
            
            if (items.length > 0) {
                // Remove any existing last-media-item class from previous items
                $('.last-media-item').removeClass('last-media-item');
                
                // Get the last item and add class
                const lastItem = items.last();
                lastItem.addClass('last-media-item');
                
                // Also ensure any existing overlays on other images are removed
                $('.product__media-item:not(.last-media-item) .overlay-text, .product__media-item:not(.last-media-item) .overlay-wrapper').remove();
                
                // Check if overlay image already exists to avoid duplicates
                if ($('.product__media-wrapper .last-media-item .overlay-image').length === 0) {
                    // Create the overlay image element
                    var overlayImage = $('<img class="overlay-image last-overlay" src="https://cdn.shopify.com/s/files/1/0907/3927/8131/files/easter-overlay-1.png?v=1774430266" style="position: absolute; bottom: 0; width: 100%; z-index: 2; pointer-events: none;">');
                    
                    // Find the media container inside the last item and append the overlay
                    var mediaContainer = $('.product__media-wrapper .last-media-item .product-media-container');
                    
                    // Make sure the container has position relative for absolute positioning of overlay
                    mediaContainer.css('position', 'relative');
                    
                    // Append the overlay image
                    mediaContainer.append(overlayImage);
                    
                    console.log('Overlay image added to last product image');
                }
                
                // Optional: Stop observing once the overlay has been added
                observer.disconnect();
            }
        });
        
        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Also listen for thumbnail clicks to ensure overlays only show on the last image
        $(document).on('click', '.thumbnail-list button', function() {
            setTimeout(function() {
                // Check if the active image is the last one
                const activeThumbnail = $('.thumbnail-list button[aria-current="true"]');
                const lastThumbnail = $('.thumbnail-list .thumbnail-list__item:last-child button');
                
                if (activeThumbnail.length > 0 && lastThumbnail.length > 0 && 
                    activeThumbnail.attr('aria-controls') === lastThumbnail.attr('aria-controls')) {
                    // We're on the last image, make sure overlays are visible
                    $('.overlay-text, .overlay-wrapper').show();
                    console.log('On last image - overlays visible');
                } else {
                    // Not on last image, hide all overlays
                    $('.overlay-text, .overlay-wrapper').hide();
                    console.log('Not on last image - overlays hidden');
                }
            }, 100);
        });
    });
});

$(document).ready(function() {
    // Check when custom fields are loaded
    var checkElementInterval = setInterval(function() {
        if ($('.product-custom-fields-container .product-custom-field-item').length) {
            clearInterval(checkElementInterval);
            
            $('select.product-custom-field-input').each(function() {
                var $originalSelect = $(this);
                
                // Create swatch container
                var $swatchContainer = $('<div class="swatch-container"></div>');
                
                // Insert swatch container after the original select
                $originalSelect.after($swatchContainer);
                
                // Hide original select but keep it functional
                $originalSelect.css({
                    'position': 'absolute',
                    'opacity': 0,
                    'pointer-events': 'none',
                    'height': 0,
                    'width': 0
                });
                
                // Add swatch options
                $originalSelect.find('option').each(function() {
                    var optionValue = $(this).val();
                    var optionText  = $(this).text();
                    
                    if (optionValue === '') return;

                    $('<div class="swatch-option"></div>')
                        .text(optionText)
                        .toggleClass('selected', $(this).is(':selected'))
                        .click(function(e) {
                            if ($swatchContainer.hasClass('dragging')) return;

                            // Set select value
                            $originalSelect.val(optionValue);

                            // Update selected swatch
                            $swatchContainer.find('.swatch-option').removeClass('selected');
                            $(this).addClass('selected');

                            // Trigger both jQuery + native change
                            $originalSelect.trigger('change');
                            $originalSelect[0].dispatchEvent(new Event("change", { bubbles: true }));

                            // Shopify-specific
                            if (typeof CustomFields !== 'undefined' && typeof CustomFields.onInputChange === 'function') {
                                CustomFields.onInputChange($originalSelect[0]);
                            }
                        })
                        .appendTo($swatchContainer);
                });
                
                // Add mouse drag scrolling functionality
                let isDown = false;
                let startX;
                let scrollLeft;

                $swatchContainer.on('mousedown', function(e) {
                    isDown = true;
                    startX = e.pageX - $swatchContainer.offset().left;
                    scrollLeft = $swatchContainer.scrollLeft();
                    $swatchContainer.addClass('dragging');
                });

                $(document).on('mouseup', function() {
                    isDown = false;
                    $swatchContainer.removeClass('dragging');
                });

                $(document).on('mousemove', function(e) {
                    if (!isDown) return;
                    e.preventDefault();
                    const x = e.pageX - $swatchContainer.offset().left;
                    const walk = (x - startX) * 2;
                    $swatchContainer.scrollLeft(scrollLeft - walk);
                });
                
                // Update selected swatch based on the original select's value
                $originalSelect.on('change', function() {
                    var val = $(this).val();
                    $swatchContainer.find('.swatch-option').removeClass('selected');
                    $swatchContainer.find('.swatch-option').filter(function() {
                        return $(this).text() === $originalSelect.find('option:selected').text();
                    }).addClass('selected');
                });
            });
        }
    }, 100);
});


function shrinkOverlayText(selector, minFontSize = 10) {
    const elements = document.querySelectorAll(selector);

    elements.forEach(el => {
        el.style.fontSize = '115px';

        const containerWidth = el.clientWidth;
        let fontSize = parseFloat(window.getComputedStyle(el).fontSize);

        while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
            fontSize -= 1;
            el.style.fontSize = fontSize + 'px';
        }
    });
}

// Run once on page load
shrinkOverlayText('.overlay-text.name-overlay');

// Run again on window resize for responsiveness
window.addEventListener('resize', () => {
    shrinkOverlayText('.overlay-text.name-overlay');
});





